/*
 * Main JS
 * -------------------
 * This file contains global JS functionality.
 */
import '../base/global';
import '../modules/gwp-incart-hydrator';
import '../components/product-card-modal';

// Initialize gift wrap system
import '../gift-wrap/src/services/initializeGiftWrap';

// Check if environment app ID is configured.
const environmentAppId = window.environmentAppId || window.settings?.environment_app_id;
if (!environmentAppId || environmentAppId.trim() === '') {
  console.error('❌ Environment App ID is missing or empty. Please configure settings.environment_app_id.');
}
